import { useMemo } from 'react';
import { useServices } from 'app/hooks';
import { WidgetType } from 'widgets/WidgetType';
import { MyPortfolioCapsuleWidgetStrategy } from 'widgets/myPortfolioCapsules/MyPortfolioCapsuleWidgetStrategy';

export function useMyPortfolioCapsuleWidgetStrategies() {
    const { myPortfolioCapsuleService } = useServices();
    return useMemo(() => {
        return myPortfolioCapsuleService.getStrategies();
    }, [myPortfolioCapsuleService]);
}

export function useMyPortfolioCapsuleWidgetStrategy(
    widgetType: WidgetType
): MyPortfolioCapsuleWidgetStrategy {
    const strategies = useMyPortfolioCapsuleWidgetStrategies();
    return useMemo(() => {
        const strategy = strategies.find((s) => s.type === widgetType);
        if (!strategy) {
            throw new Error(
                `${widgetType} is not a supported MyPortfolioCapsuleWidget capsule`
            );
        }
        return strategy.strategy;
    }, [strategies, widgetType]);
}
